module.exports = __webpack_public_path__ + "static/media/link-icon.72e35772.svg";